import React from 'react';
import styled from 'styled-components';
import { IconProps } from '@typings/common/icon.interface';
import Color from '@styles/Color';

const SvgBox = styled.span<{
  size?: number;
}>`
  width: ${({ size }) => size || 18}px;
  height: ${({ size }) => size || 18}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function EyeCloseIcon(props: IconProps) {
  const { size = 18, color } = props;

  return (
    <SvgBox size={size} role="img" aria-label="eye-close">
      <svg viewBox="0 0 18 16" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.73999 15C1.83999 15.1 1.97999 15.15 2.10999 15.15C2.23999 15.15 2.36999 15.1 2.47999 15L15.73 1.74003C15.94 1.54003 15.94 1.21003 15.73 1.00003C15.53 0.790029 15.2 0.790029 14.99 1.00003L1.73999 14.26C1.52999 14.46 1.52999 14.79 1.73999 15ZM9 1.91003C4.39 1.91003 0.799998 7.44003 0.649998 7.68003C0.529998 7.87003 0.529998 8.12003 0.649998 8.33003L0.661193 8.34694C0.79167 8.54433 1.65923 9.85684 3.03 11.16L3.88 10.31C2.93 9.40003 2.22 8.47003 1.88 8.00003C2.7 6.86003 5.64 3.10003 9 3.10003C9.6 3.10003 10.19 3.22003 10.75 3.42003L11.67 2.50003C10.84 2.14003 9.94 1.91003 9 1.91003ZM17.35 7.68003L17.3371 7.66055C17.1947 7.44432 16.2206 5.9655 14.7 4.57003L13.85 5.42003C14.94 6.43003 15.75 7.48003 16.12 8.00003C15.3 9.14003 12.38 12.88 9 12.88C8.26 12.88 7.55 12.7 6.86 12.4L5.96 13.31C6.9 13.78 7.92 14.08 9 14.08C13.5948 14.08 17.1763 8.58654 17.3484 8.32249L17.35 8.32003C17.47 8.12003 17.47 7.87003 17.35 7.68003ZM9.81998 9.46001L9.80998 9.48001C9.67998 9.70001 9.50998 9.85001 9.33998 9.94001L8.20998 11.07C8.44998 11.19 8.72998 11.25 8.99998 11.25C10.34 11.25 11.39 9.82001 11.39 8.01001V7.89001L9.81998 9.46001ZM8.99998 4.76001C7.77998 4.76001 6.78998 5.95001 6.63998 7.54001L9.38998 4.79001C9.33897 4.78637 9.29061 4.78139 9.24345 4.77655C9.1612 4.76809 9.08261 4.76001 8.99998 4.76001Z"
          fill="var(--subTextColor)"
        />
      </svg>
    </SvgBox>
  );
}
export default EyeCloseIcon;
